import { render } from "./DeleteBox.vue?vue&type=template&id=608fead1&scoped=true"
import script from "./DeleteBox.vue?vue&type=script&lang=js"
export * from "./DeleteBox.vue?vue&type=script&lang=js"

import "./DeleteBox.vue?vue&type=style&index=0&id=608fead1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608fead1"]])

export default __exports__